<template>
  <nav class="navbar navbar-inverse navbar-bottom" style="padding:0 0 120px 0">
    <div class="container">
      <div>
        <div class="col-12">
          <router-link
            to="/home"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'home'}"
            data-target=".navbar-collapse.show"
          >Home</router-link>
          <span class="footer-link-saperator">|</span>
          <router-link
            to="/achievements"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'achievements'}"
            data-target=".navbar-collapse.show"
          >Achievements</router-link>
          <span class="footer-link-saperator">|</span>
          <router-link
            to="/tools"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'tools'}"
            data-target=".navbar-collapse.show"
          >Tools</router-link>
          <span class="footer-link-saperator">|</span>
          <router-link
            to="/about"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'about'}"
            data-target=".navbar-collapse.show"
          >About</router-link>
          <span class="footer-link-saperator">|</span>
          <router-link
            to="/contact"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'contact'}"
            data-target=".navbar-collapse.show"
          >Contact</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: function () {
    return {
      ActiveRoute : null,
    };
  },
};
</script>

<style>
.navbar-bottom {
  min-height: 50px;
  margin-top: 230px;
  padding-top: 35px;
  color: #ffffff;
  z-index: 98;
}

.footer-link-saperator {
  margin-left: 5px;
  margin-right: 5px;
  color: #2c5586;
  font-weight: bold;
}

.navbar-bottom a {
  font-size: 12px;
  color: #adc9ce;
}

.router-link-active {
  color: #ff5f96 !important;
  font-weight: bold;
}
</style>